import CommonConstans from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import Store from '@/common/utils/Store'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'C00G1030',
  components: {}
  })
export default class C00G1030Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const messageError = JSON.parse(
      SessionStorageService.getItem(CommonConstans.MESSAGE_ERROR)
    )
    Store.setResponseErrors(messageError)
  }
}
